import { useFeature } from 'flagged';
import getPlatform from '../helpers/getPlatform';
import { ConfigFeatureFlags } from '../services/service-config-types';
import useAccountFeatures from './use-account-features';
var useSpendingTrendsFeature = function () {
    var selectedPlatform = getPlatform();
    var accountFeatures = useAccountFeatures({ selectedPlatform: selectedPlatform });
    var flagEnabled = useFeature(ConfigFeatureFlags.spendingTrends);
    return flagEnabled && Boolean(accountFeatures === null || accountFeatures === void 0 ? void 0 : accountFeatures.accessToSpendManagement);
};
export default useSpendingTrendsFeature;
//# sourceMappingURL=use-spending-trends-feature.js.map